import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Box, IconButton } from '@mui/material';
import Iconify from '../../../components/iconify';
import AccountPopover from './AccountPopover';
import { useSelector } from 'react-redux';
import { getPageMeta } from '../pageMeta';
import PlatformIcon from '../../../components/platform/PlatformIcon';
import '../../../styles/platform-dashboard.css';

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const { pathname } = useLocation();
  const { user, company } = useSelector((state) => state.auth || {});
  const { title, subtitle } = getPageMeta(pathname);

  const displayName = user?.name || user?.displayName || user?.firstName || 'Admin';
  const companyName = user?.companyName || company?.companyName || 'Organization';

  return (
    <header className="dashboard-app-header">
      <div className="dashboard-app-header-inner">
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
            flexShrink: 0,
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <div className="dashboard-app-header-copy">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>

        <div className="dashboard-app-header-actions">
          <div className="dashboard-app-header-search">
            <PlatformIcon name="search" size={17} />
            <span>Search…</span>
          </div>

          <button type="button" className="dashboard-app-header-bell" aria-label="Notifications">
            <PlatformIcon name="bell" size={18} />
            <span className="dashboard-app-header-bell-dot" />
          </button>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, ml: 0.5 }}>
            <Box sx={{ textAlign: 'right', display: { xs: 'none', sm: 'block' } }}>
              <Box sx={{ fontSize: 14, fontWeight: 600, color: '#1B241F', lineHeight: 1.2 }}>
                {displayName}
              </Box>
              <Box sx={{ fontSize: 12, color: '#6C766F', lineHeight: 1.2 }}>
                {companyName}
              </Box>
            </Box>
            <AccountPopover />
          </Box>
        </div>
      </div>
    </header>
  );
}
